jQuery(($) => {

  // Create store object
  const ProjB = {
    // MOBILE
    isMobile: () => {
      return $(window).width() < 768;
    },

    mobileMenu: () => {
      $mobileNav = $('#mobile-navigation');
      // $mobileNav.hide();
      $('#toggle-menu').on('click', () => {
        if ($mobileNav.css("display") === "none") {
          $mobileNav.slideDown();
        } else {
          $mobileNav.slideUp();
        }
      });
    },

    setupMobile: () => {
      if (ProjB.isMobile()) {
        $('.container').addClass('mobile');
      }
      $(window).resize(() => {
        $searchField.addClass('hidden'); // hide search field if showing on resize
        if (ProjB.isMobile()) {
          $('.container').addClass('mobile');
        } else {
          $('.container').removeClass('mobile');
        }
      })
    },
    // END MOBILE

    // HEADER
    searchFormToggle: () => {
      $searchField = $('.header #search-field');
      $searchFieldMobile = $('.header-mobile #search-field');

      $('.submit-search').on("click", (e) => {
        if (ProjB.isMobile()) {
          if ($searchFieldMobile.hasClass('hidden')) {
            $searchFieldMobile.removeClass('hidden');
          } else {
            const val = $searchFieldMobile.val();
            if (val.length > 0) {
              $('.header-mobile .search-form-nav form').submit();
            }
            $searchFieldMobile.addClass('hidden');
          }

        } else {
          let x = e.pageX;
          let y = 0;
          if (window.innerWidth > 1600) {
            const w = (window.innerWidth - 1600) / 2;
            x = x - w;
          }
          const left = x - 150 - 34 + 'px';
          const top = y + 'px';
          $searchField.css("left", left);
          $searchField.css("top", top);
          if ($searchField.hasClass('hidden')) {
            $searchField.removeClass('hidden');
          } else {
            const val = $searchField.val();
            if (val.length > 0) {
              $('.header .search-form-nav form').submit();
            }
            $searchField.addClass('hidden');
          }
        }

      });
    },
    // END HEADER

    // PRODUCT SPECIFIC
    showCorrectButton: () => {
      if ($('body.template-product').length > 0) {
        const $amazonLink = $('#amazon');
        if ($amazonLink.length > 0) {
          $('.external').show();
          const link = $amazonLink.data("amazon");
          $('form#product-form').on("submit", e => {
            e.preventDefault();
            window.open(link);
          });
        } else {
          $('#product-price').show(); // show price
          $('.internal').show();
        }

      }
    },
    // END PRODUCT SPECIFIC

    // POPUPS & GALLERIES
    // // When user clicks on gallery link, then 'close' in the viewer, user is returned to last page viewed
    // UPDATE: not used now, maybe later?
    // listenToGalleryLink: () => {
    //   $('.gallery-link').on('click', e =>{
    //     console.log('gal link clicked');
    //     // window.sessionStorage.setItem('returnTo', window.location.pathname);
    //   });
    //   // $('.close').on('click', () => {
    //   //   const returnTo = window.sessionStorage.getItem("returnTo");
    //   //   if (returnTo) {
    //   //     window.location = returnTo;
    //   //     window.sessionStorage.clear();
    //   //   } else {
    //   //     window.location = "/";
    //   //   }
    //   // });
    // },

    // modalMadness: () => {
    //   document.addEventListener('click', e => {
    //     if (e.target.parentNode.classList.contains('modal-link')) {
    //       e.preventDefault();
    //       const a = e.target.parentNode;
    //       const title = a.getAttribute("data-title");
    //       const href = a.href;
    //       ProjB.populateModal(href, title);
    //     }
    //   }, false);
    // },

    adjustImageSizes: () => {
      if (!ProjB.isMobile()) {
        const images = document.querySelectorAll('.slide-background img')

        if (images.length > 0) {
          images.forEach(i => {
            const imageHeight = i.height;
            const imageWidth = i.width;

            const windowHeight = window.innerHeight;
            if (imageHeight > windowHeight * .75) {
              const targetHeight = windowHeight * .75;
              const targetWidth = (targetHeight / imageHeight) * imageWidth;
              i.style.height = targetHeight + "px";
              i.style.width = targetWidth + "px";
            }
          });
        }
      }
    },

    // adjustModalHeight: (modalImage) => {
    //   if (!ProjB.isMobile()) {
    //     const windowHeight = window.innerHeight;
    //     const modalImageHeight = modalImage.height;
    //     const modalImageWidth = modalImage.width;
    //     const modalContent = document.querySelector("#modal-content");
    //     const modalContentHeight = modalContent.offsetHeight;

    //     if (modalContentHeight > windowHeight) {
    //       const targetHeight = windowHeight * .8;
    //       const targetWidth = (targetHeight / modalImageHeight) * modalImageWidth;

    //       modalImage.style.height = targetHeight + "px";
    //       modalImage.style.width = targetWidth + "px";
    //     }
    //   } else {
    //     modalImage.style.height = "100%";
    //     modalImage.style.width = "100%";
    //   }
    // },

    // populateModal: (imageSrc, titleText) => {
    //   const modalWindow = document.querySelector('#modal-window');
    //   const modalImage = document.querySelector('#modal-image');
    //   const modalText = document.querySelector('#modal-text');
    //   modalWindow.classList.add('active');
    //   modalImage.src = imageSrc;
    //   modalImage.alt = titleText;
    //   modalText.innerHTML = titleText;
    //   modalImage.addEventListener("load", (e) => {
    //     e.preventDefault();
    //     ProjB.adjustModalHeight(modalImage);
    //   });
    // },

    // clearModal: (modalImage, modalText) => {
    //   modalImage.alt = "";
    //   modalImage.src = "";
    //   modalText.innerHTML = "";
    //   modalImage.style = "";
    // },

    // closeModal: () => {
    //   const modalWindow = document.querySelector("#modal-window");
    //   const modalClose = document.querySelector("#modal-close");
    //   const modalImage = document.querySelector('#modal-image');
    //   const modalText = document.querySelector('#modal-text');
    //   if (modalClose) {
    //     modalClose.addEventListener("click", e => {
    //       e.preventDefault();
    //       modalWindow.classList.remove("active");
    //       ProjB.clearModal(modalImage, modalText);
    //     });
    //   }
    // },

    // modalInit: () => {
    //   ProjB.modalMadness();
    //   ProjB.closeModal();
    // },

    galleryInit: () => {
      const $popUpPage = $("body[id^=project-b-pop-up-]");
      if ($popUpPage.length > 0) {
        // popUp needs footer totally removed else it pops up (see code below)!
        $('footer').remove();

        gallery = new Swiper('.swiper-container', {
          direction: 'horizontal',
          loop: true,
          hashNavigation: {
            replaceState: true,
          },
          pagination: {
            el: '.swiper-pagination',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });
        ProjB.adjustImageSizes();
      }

    },

    // ensure popup images shrink if window does
    watchResize: () => {
      window.addEventListener('resize', () => {
        ProjB.adjustImageSizes();
      })
    },
    // END POPUPS & GALLERIES

    // SCROLL SPECIFIC
    lastKnownPos: 0,
    moving: false,

    hideFooter: (scrollPos) => {
      if (scrollPos > ProjB.lastKnownPos) {
        $('footer').slideDown();
      } else if (scrollPos < ProjB.lastKnownPos + 10) {
        $('footer').slideUp();
      }
      ProjB.lastKnownPos = scrollPos;
    },

    atBottom: () => {
      const docEl = document.documentElement;
      let docOffset = docEl.offsetHeight;
      let height = docEl.scrollTop + window.innerHeight;
      if (height === docOffset) {
        $('footer').removeClass('scrolling');
      } else {
        $('footer').addClass('scrolling');
      }
    },

    scrollToAnchor: () => {
      const anchors = document.querySelectorAll('.same-page');
      if (anchors.length > 0) {
        anchors.forEach(a => {
          const id = a.hash;
          const el = document.querySelector(id);
          const top = (el.offsetTop - 300);

          a.addEventListener('click', e => {
            e.preventDefault();

            window.scrollTo({
              top: top,
              left: 0,
              behavior: 'smooth'
            });
          })
        });
      }
    },

    // highlight footer if content expands beyond on scroll
    watchScroll: () => {
      window.addEventListener("scroll", () => {
        let currrentPos = window.scrollY;

        if (!ProjB.moving && ProjB.isMobile()) {
          window.requestAnimationFrame(() => {
            ProjB.hideFooter(currrentPos);
            ProjB.moving = false;
          });
          ProjB.moving = true;
        }

        ProjB.atBottom();
      });
    },
    // END SCROLL SPECIFIC

    // COPYRIGHT ON RIGHT CLICK
    contentCopyright: () => {
      const year = new Date().getFullYear();
      const msg = "Copyright " + year + " PROJECT B, all rights reserved. \nWant to use our images? Ask us!\nhttps://www.projectb.com/pages/contact";
      const msg2 = "Copyright " + year + " PROJECT B, all rights reserved.<br>Want to use our images? <a href='https://www.projectb.com/pages/contact'>Ask us</a>!";

      if (window.notifyNonsense) {
        const options = {
          global: true,
          text: msg2,
          type: 'nn-alert',
          event: 'contextmenu'
        }
        notifyNonsense.init(options)

      } else {
        $(window).bind("contextmenu", function (e) {
          alert(msg);
          return false;
        });
      }

    },

    init: () => {
      ProjB.setupMobile();
      ProjB.mobileMenu();
      ProjB.searchFormToggle();
      ProjB.contentCopyright();
      ProjB.galleryInit();
      ProjB.watchScroll();
      ProjB.showCorrectButton();
      // ProjB.listenToGalleryLink();
      // ProjB.modalInit();
      ProjB.watchResize();
      ProjB.scrollToAnchor();
    }

  };

  $(window).on('load', () => {
    ProjB.init();
    modalMadness.init();
  });

});
